import { generateSearchParams } from '@/utils/generateSearchParams';
import { request } from '@/utils/request';
import { ResponseBasis } from '@/api/api.types';
import {
  ITestimonialItem,
  TestimonialCreateBody,
  TestimonialsListOptions,
} from '@/api/testimonials/testimonials.types';

export async function getTestimonialsList(options: TestimonialsListOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<ITestimonialItem>>(`/testimonial/?${searchParams.toString()}`);
}

export async function createTestimonial(data: TestimonialCreateBody) {
  return request('/testimonial/create', {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
}